import { getMaintenanceServiceImage } from '../../api/maintenance-service.ts';
import { useQueries, UseQueryResult } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ImagePair } from '../../models/PlaceService.ts';

export default function useMaintenanceServiceImages(
  serviceId: string,
  imageIds: string[],
  options?: { enabled?: boolean },
): UseQueryResult<ImagePair, Error>[] {
  const queries = useMemo(() => {
    if (!serviceId || !imageIds) return [];

    return imageIds.map((imageId) => ({
      queryKey: ['maintenanceServices', serviceId, 'images', imageId] as const,
      queryFn: async () => {
        const res = await getMaintenanceServiceImage({ serviceId, imageId });
        const returnPair: ImagePair = {
          imageId: imageId,
          signedUrl: res?.signedUrl ?? '',
        };
        return returnPair || null;
      },
      enabled: !!serviceId && !!imageId && (options?.enabled ?? true),
    }));
  }, [serviceId, imageIds, options?.enabled]);

  return useQueries({
    queries,
  }) as UseQueryResult<ImagePair, Error>[];
}
